// Common create slug helper for cue / brightcove / newsgate and text
export function createSlug(props: CreateSlug) {
    switch (props.type) {
        case 'cue':
            return sanitiseSlug(`${props.headline}-${props.id}`)
        case 'newsgate':
            return sanitiseSlug(`${props.headline}-ng-${props.id}`)
        case 'brightcove':
            return sanitiseSlug(`${props.title}-bc-${props.id}`)
        case 'text':
            return sanitiseSlug(props.text)
    }
}

/**
 * Be very careful if changing this as some migrations seem to be using it
 * they will need to be updated so that no issues occur
 */
function sanitiseSlug(text: string): string {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\s/g, '-')
        .replace('---', '-')
}

type CreateSlug =
    | {
          type: 'cue' | 'newsgate'
          headline: string
          id: string
      }
    | {
          type: 'brightcove'
          title: string
          id: string
      }
    | {
          type: 'text'
          text: string
      }
